import React from 'react';
import CircularProgress from 'material-ui/CircularProgress';

const Loader = () => (
  <div className="valign-wrapper">
    <div className="valign">
      <CircularProgress size={80} thickness={5} />
    </div>
  </div>
);

export default Loader;


// WEBPACK FOOTER //
// ./src/components/Loader/index.js